import React from 'react';
import * as s from './styled-medicao';

const Medicao = ({ medicao, color, value }) => {
  return (
    <s.Container>
      <s.Medicao title={medicao}> {medicao}</s.Medicao>
      <s.Value title={value} color={color}>
        {value}
      </s.Value>
    </s.Container>
  );
};

export default Medicao;
